<div class="bg-[#F9FBFF] min-h-screen px-4 relative">
  <div class="flex flex-row w-full items-center justify-between pt-4">
    <div class="h-[40px]">
      <img src="/assets/logo-horizontal.png" class="w-full h-full object-contain" alt="Royal Hospital Logo" />
    </div>
    <div tuiButton title="user-dropdown" type="button" class="cursor-pointer" [tuiDropdown]="content"
      [(tuiDropdownOpen)]="open" [tuiDropdownAlign]="align">
      <div class="flex items-center space-x-3 mr-5">
        <div class="w-[30px] h-[30px] bg-red-600 rounded-full">
          <img class="object-cover w-full h-full rounded-full"
            src="{{ loggedInUserRole == 'NURSE' ? loggedInUserImage : 'https://placehold.net/avatar.svg' }}" alt="" />
        </div>
        <div class="flex flex-col items-start">
          <p class="text-[#6B6D80] text-xs font-semibold m-0 p-0">
            {{ loggedInUserName }}
          </p>
          <p class="text-[#474747] text-xs font-normal m-0 p-0">
            {{ loggedInUserRole }}
          </p>
        </div>
      </div>
    </div>

    <ng-template #content>
      <tui-data-list tuiDataListDropdownManager [size]="size">
        <button tuiOption type="button" class="logout" (click)="logout()">
          <span style="color: red">Logout</span>
        </button>
      </tui-data-list>
    </ng-template>
  </div>

  <div class="mt-4 custom-border rounded-t-2xl bg-white flex flex-col justify-between"
    style="min-height: calc(100vh - 75px)">
    <div class="p-4">
      <router-outlet />
    </div>

    <div class="">
      <hr />
      <div class="flex flex-row justify-between items-center px-4">
        <div>
          <p class="font-normal text-xs text-[#1E293B]">
            Royal Hospital | Version 1.4.10
          </p>
        </div>
        <div>
          <p class="font-normal text-xs text-[#1E293B]">
            Powered by
            <a href="https://www.purple.lk/?utm_source=Home Nursing Management System" target="_blank" rel="noopener"
              class="text-[#6C066D] no-underline">Purple Software
            </a>
          </p>
        </div>
      </div>
    </div>
  </div>
</div>